import React from 'react';
import { IconTwitter, IconInstagram, VisuallyHidden, TypeList, TypeListItem } from '@spotify-internal/encore-web';
import { ResponsiveLogo, Link } from '../../ui';
import androidIcon from '../images/footer-android.svg';
import iosIcon from '../images/footer-ios.svg';
import { FooterWrapper, FooterSection, SectionHeader, InlineList, CircleIcon, Copyright } from './Footer.styles';
import { useT } from '@mrkt/features/i18n';
import { useFooterLabels } from './useFooterLabels';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TRACK_CAT = 'Footer';
var YEAR = new Date().getFullYear();
export var Footer = function Footer() {
  var t = useT();
  var footerLabels = useFooterLabels();
  return /*#__PURE__*/_jsxs(FooterWrapper, {
    children: [/*#__PURE__*/_jsx(FooterSection, {
      children: /*#__PURE__*/_jsx(Link, {
        href: "/?ref=footer",
        track: [TRACK_CAT, 'Logo'],
        highlight: true,
        "data-testid": "footer-logo",
        children: /*#__PURE__*/_jsx(ResponsiveLogo, {})
      })
    }), /*#__PURE__*/_jsxs(FooterSection, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        children: t('FRODOR_FINE_PRINT_FOOTER', 'Fine Print', 'Fine Print refers to terms and conditions')
      }), /*#__PURE__*/_jsxs(TypeList.ul, {
        children: [/*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-legal",
            href: "https://www.spotify.com/legal/spotify-for-artists-terms-and-conditions/",
            external: true,
            track: [TRACK_CAT, 'Legal'],
            children: t('FRODOR_LEGAL_LINK_TEXT_FOOTER', 'Legal', 'Legal refers to terms and conditions')
          })
        }), /*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-privacy",
            href: "https://www.spotify.com/legal/privacy-policy",
            external: true,
            track: [TRACK_CAT, 'Privacy Policy'],
            children: t('FRODOR_a92e8f', 'Privacy Policy', '')
          })
        }), /*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-cookies",
            href: "https://www.spotify.com/legal/cookies-policy/",
            external: true,
            track: [TRACK_CAT, 'Cookies'],
            children: t('FRODOR_COOKIES_LINK_TEXT_FOOTER', 'Cookies', 'Cookies are a user tracking method for the web')
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(FooterSection, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        children: t('FRODOR_7bfbb4', 'Need help?', '')
      }), /*#__PURE__*/_jsxs(TypeList.ul, {
        children: [/*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            href: "/contact",
            track: [TRACK_CAT, 'Contact Us'],
            "data-testid": "footer-contact",
            children: t('FRODOR_51f8e4', 'Contact Us', '')
          })
        }), /*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-claim",
            href: "/claim",
            track: [TRACK_CAT, 'Get Access'],
            children: t('FRODOR_d84abd', 'Get Access', '')
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(FooterSection, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        children: t('FRODOR_d0bb36', 'Creator tools', '')
      }), /*#__PURE__*/_jsxs(TypeList.ul, {
        children: [/*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-anchor",
            external: true,
            href: "https://app.adjust.com/iya18ah?redirect=https%3A%2F%2Fanchor.fm%2Fapp",
            track: [TRACK_CAT, 'Creator Tools - Anchor'],
            children: t('FRODOR_256bed', 'Anchor', '')
          })
        }), /*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-soundtrap",
            external: true,
            href: "https://www.soundtrap.com/?utm_source=spotify_site&utm_medium=footer_menulink&utm_campaign=alwayson_global_soundtrap_destination",
            track: [TRACK_CAT, 'Creator Tools - Soundtrap'],
            children: t('FRODOR_4fdeca', 'Soundtrap', '')
          })
        }), /*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-s4p",
            external: true,
            href: "https://podcasters.spotify.com/?utm_source=artists.spotify.com",
            track: [TRACK_CAT, 'Creator Tools - Spotify for Podcasters'],
            children: t('FRODOR_8e3734', 'Spotify for Podcasters', '')
          })
        }), /*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-spa",
            external: true,
            href: "https://noteable.spotify.com/?utm_source=artists.spotify.com",
            track: [TRACK_CAT, 'Creator Tools - Noteable'],
            children: "Noteable"
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(FooterSection, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        children: t('FRODOR_FOLLOW_US_FOOTER', 'Follow us', 'Follow refers to a feature of Twitter')
      }), /*#__PURE__*/_jsxs(InlineList, {
        children: [/*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsxs(Link, {
            "data-testid": "footer-twitter",
            highlight: true,
            external: true,
            href: "https://twitter.com/spotifyartists",
            track: [TRACK_CAT, 'Social - Twitter'],
            children: [/*#__PURE__*/_jsx(CircleIcon, {
              as: IconTwitter,
              "aria-label": "Twitter"
            }), /*#__PURE__*/_jsx(VisuallyHidden, {
              children: "Twitter"
            })]
          })
        }), /*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsxs(Link, {
            "data-testid": "footer-instagram",
            highlight: true,
            external: true,
            href: "https://www.instagram.com/spotifyforartists/",
            track: [TRACK_CAT, 'Social - Instagram'],
            children: [/*#__PURE__*/_jsx(CircleIcon, {
              as: IconInstagram,
              "aria-label": "Instagram"
            }), /*#__PURE__*/_jsx(VisuallyHidden, {
              children: "Instagram"
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(FooterSection, {
      children: [/*#__PURE__*/_jsx(SectionHeader, {
        children: t('FRODOR_GET_THE_APP_SECTION_HEADER_FOOTER', 'Get the app', 'App is short for application')
      }), /*#__PURE__*/_jsxs(TypeList.ul, {
        children: [/*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-ios",
            highlight: true,
            external: true,
            href: "https://itunes.apple.com/us/app/spotify-for-artists/id1222021797",
            track: [TRACK_CAT, 'iOS App'],
            children: /*#__PURE__*/_jsx("img", {
              "data-src": iosIcon,
              alt: footerLabels.appStore,
              className: "lazyload"
            })
          })
        }), /*#__PURE__*/_jsx(TypeListItem, {
          children: /*#__PURE__*/_jsx(Link, {
            "data-testid": "footer-android",
            highlight: true,
            external: true,
            href: "https://play.google.com/store/apps/details?id=com.spotify.s4a",
            track: [TRACK_CAT, 'Android App'],
            children: /*#__PURE__*/_jsx("img", {
              "data-src": androidIcon,
              alt: footerLabels.googlePlay,
              className: "lazyload"
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(FooterSection, {
      children: /*#__PURE__*/_jsxs(Copyright, {
        "data-testid": "footer-copyright",
        children: ["\xA9 ", YEAR, " Spotify AB"]
      })
    })]
  });
};